@if ((notifications$ | async)?.length === 0 && !(notificationsLoading$ | async)) {
  <ct-lib-empty-placeholder [title]="'company-tool.topnav.notifications.no-notifications' | transloco" text="" [icon]="fontawesomeService.light.bell"></ct-lib-empty-placeholder>
}
@for (notification of notifications$ | async; track notification) {
<div
  class="notification interactive"
  [routerLink]="generateRouterLink(notification)"
  (click)="toggleNotificationState(notification, true); openCompanyChat(notification); notificationNavigate.emit()"
>
  <div class="header">
    <div>
      @if (!notification.seen) {
      <fa-icon [icon]="fontawesomeService.solid.dot"></fa-icon>
      }
      @switch (notification.type) {
        @case ('NewApplicationNotification') {
      <span
        >{{ 'company-tool.topnav.notifications.new-application.title' | transloco }} ({{
          'company-tool.topnav.notifications.new-application.' +
            (notification.incomplete ? (notification.addedData ? 'incomplete' : 'active-sourcing') : 'complete')
            | transloco
        }})</span
      >
        }
        @case ('NewJobNotification') {
      <span>{{
        'company-tool.topnav.notifications.new-job.title' | transloco
      }}</span>
        }
        @case ('NewCommentNotification') {
      <span>{{
        'company-tool.topnav.notifications.new-comment.title' | transloco
      }}</span>
        }
        @case ('NewEMailNotification') {
      <span>{{
        'company-tool.topnav.notifications.new-email.title' | transloco
      }}</span>
        }
        @case ('ReminderNotification') {
      <span>{{
        'company-tool.topnav.notifications.reminder.title' | transloco
      }}</span>
        }
      }
    </div>
    <span>{{ notification.timestamp | date: 'short' }}</span>
  </div>
  <div class="body">
    @switch (notification.type) {
      @case ('NewApplicationNotification') {
    <div class="content">
      <div class="avatar">
        @if (notification.hasProfilePicture && (getAvatarURL(notification.applicationID) | avatar | async); as image) {
          <img [src]="image" alt="" />
        } @else {
          <app-avatar-placeholder
            [initials]="getInitials(notification.applicantName)"
          ></app-avatar-placeholder>
        }
      </div>
      <span>
        <b>{{ notification.applicantName }}</b>
        <br />
        {{ notification.jobTitle }}
      </span>
    </div>
      }
      @case ('NewCommentNotification') {
    <div class="content">
      <div class="icon-wrapper">
        <fa-icon [icon]="fontawesomeService.light.comment"></fa-icon>
      </div>
      @if (notification.jobID || notification.applicationID) {
      <span>
        {{ 'company-tool.topnav.notifications.new-comment.to' | transloco }}
        <b>{{ notification.applicantName }}</b>
        ({{
          notification.jobID
            ? notification.jobTitle
            : ('company-tool.topnav.notifications.new-comment.talentpool' | transloco)
        }})
        <br />
        {{ 'company-tool.topnav.notifications.new-comment.from' | transloco }} <b>{{ notification.author }}</b>
        <br /><br />
        <i [innerHTML]="notification.text"></i>
      </span>
      } @else {
      <span>
        <span
          [innerHTML]="
            'company-tool.topnav.notifications.new-comment.company-chat' | transloco: { name: notification.author }
          "
        ></span>
        <br /><br />
        <i [innerHTML]="notification.text"></i>
      </span>
      }
    </div>
      }
      @case ('NewJobNotification') {
    <div class="content">
      <div class="icon-wrapper">
        <fa-icon [icon]="fontawesomeService.light.list"></fa-icon>
      </div>
      <span>
        {{ 'company-tool.topnav.notifications.new-job.from' | transloco }}
        <b>{{ notification.jobAuthor }}</b>
        <br />
        {{ notification.jobTitle }}
        <br />
        <i>{{ notification.shortJobTitle }}</i>
      </span>
    </div>
      }
      @case ('NewEMailNotification') {
    <div class="content">
      <div class="icon-wrapper">
        <fa-icon [icon]="fontawesomeService.light.envelope"></fa-icon>
      </div>
      <span>
        {{ 'company-tool.topnav.notifications.new-email.to' | transloco }}
        <b>{{ notification.applicantName }}</b>
        <br />
        {{ notification.subject }}
      </span>
    </div>
      }
      @case ('ReminderNotification') {
    <div class="content">
      <div class="icon-wrapper">
        <fa-icon [icon]="fontawesomeService.light.bell"></fa-icon>
      </div>
      <span
        [innerHTML]="
          (timestampDifference(notification) === 1
            ? 'company-tool.topnav.notifications.reminder.day'
            : 'company-tool.topnav.notifications.reminder.days'
          ) | transloco: { name: notification.applicantName, days: timestampDifference(notification) }
        "
      ></span>
    </div>
      }
    }
    <div class="actions" (click)="$event.stopPropagation(); $event.preventDefault()">
      @if (notification.seen) {
      <app-button
        variant="ghost"
        [round]="true"
        [small]="true"
        [iconStart]="notification.seen ? fontawesomeService.light.eyeSlash : fontawesomeService.light.eye"
        [tooltip]="'company-tool.topnav.notifications.seen-tooltip' | transloco"
        position="left"
        [ariaLabel]="'company-tool.topnav.notifications.seen-tooltip' | transloco"
        (click)="toggleNotificationState(notification)"
      ></app-button>
      } @else {
      <app-button
        variant="ghost"
        [round]="true"
        [small]="true"
        [iconStart]="notification.seen ? fontawesomeService.light.eyeSlash : fontawesomeService.light.eye"
        [tooltip]="'company-tool.topnav.notifications.not-seen-tooltip' | transloco"
        position="left"
        [ariaLabel]="'company-tool.topnav.notifications.not-seen-tooltip' | transloco"
        (click)="toggleNotificationState(notification)"
      ></app-button>
      }
    </div>
  </div>
</div>
}
